import { render, staticRenderFns } from "./border.vue?vue&type=template&id=1216852b&scoped=true&"
import script from "./border.vue?vue&type=script&lang=js&"
export * from "./border.vue?vue&type=script&lang=js&"
import style0 from "./border.vue?vue&type=style&index=0&id=1216852b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1216852b",
  null
  
)

export default component.exports